import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { fetchPrivacy } from "../../api/legalApi";
import "./LegalPdf.css";

export default function PrivacyPolicy() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchPrivacy()
      .then(setData)
      .catch((err) => console.error("Error fetching privacy policy:", err));
  }, []);

  if (!data) return <div className="legal-page">Loading...</div>;

  return (
    <div className="legal-page">
      <Helmet>
        <title>Privacy Policy | 164 Diecast Zone</title>
        <meta
          name="description"
          content="Read how 164 Diecast Zone collects, uses, and protects your personal information."
        />
        <link rel="canonical" href="https://164diecastzone.com/privacy-policy" />
        <meta property="og:title" content="Privacy Policy | 164 Diecast Zone" />
        <meta property="og:url" content="https://164diecastzone.com/privacy-policy" />
      </Helmet>
      <div className="legal-container">
        <h1>Privacy Policy</h1>
        <div className="legal-meta">Last updated: {data.last_updated}</div>

        <p>
          This Privacy Policy explains how <strong>164diecastzone</strong>
          collects, uses, and protects your personal information.
        </p>

        <ul>
          <li>Personal details such as name and email</li>
          <li>Shipping and billing address</li>
          <li>Order and transaction history</li>
        </ul>

        <p>
          Your information is used only to process orders, provide support,
          and comply with legal requirements.
        </p>

        {/* ✅ Cookie information */}
        <section>
          <h2>Cookies</h2>
          <p>
            We use cookies that are necessary for the website to function properly,
            such as session cookies for your login and shopping cart. These cookies
            do not require your consent. We do not use cookies for tracking or marketing
            purposes at this time.
          </p>
        </section>

        <div className="legal-buttons">
          <a href={data.file_url} target="_blank" rel="noopener noreferrer">
            View Policy
          </a>
          <a href={data.file_url} download>
            Download Policy
          </a>
        </div>
      </div>
    </div>
  );
}
